import { QuestionnaireTemplateDetailProps } from '@/types/questionnaire';
import AdminQuestionnaireLayout from '../components/AdminQuestionnaireLayout';
import { AdminSidebarItems } from '../components/AdminSidebarItems';
import useQuestionnaireSection from './hooks/useQuestionnaireSection';
import { SectionDetails } from './components/SectionDetails';
import { SectionBreadcrumb } from './components/SectionBreadcrumb';

export default function Index({
  template,
}: {
  template: QuestionnaireTemplateDetailProps & { current_section_id: number };
}) {
  const {
    currentSectionId,
    setCurrentSectionId,
    sectionDetails,
    isSectionDetailLoading,
  } = useQuestionnaireSection({ template });
  return (
    <AdminQuestionnaireLayout
      heading={'Sections'}
      breadCrumbComponent={<SectionBreadcrumb template={template} />}
      leftComponent={
        <AdminSidebarItems
          data={template.sections}
          selectedId={currentSectionId}
          onSelect={setCurrentSectionId}
          testId="section-item"
          displayField={'section_name'}
        />
      }
      rightComponent={
        <SectionDetails
          section={sectionDetails}
          templateSections={template.sections}
          isLoading={isSectionDetailLoading}
        />
      }
    />
  );
}
